import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-slides', 'titleNav', 'Skaidrių naršymas');
Labels.set('ui-slides', 'prev', 'Kitas');
Labels.set('ui-slides', 'next', 'Ankstesnis');
Labels.set('ui-slides', 'slide', 'Skaidrė');
